export default [{
  category: 'People',
  emojis: [{
      name: 'grinning',
      image: '1f600.png'
    },
    {
      name: 'grimacing',
      image: '1f62c.png'
    },
    {
      name: 'grin',
      image: '1f601.png'
    },
    {
      name: 'joy',
      image: '1f602.png'
    },
    {
      name: 'smiley',
      image: '1f603.png'
    },
    {
      name: 'smile',
      image: '1f604.png'
    },
    {
      name: 'sweat_smile',
      image: '1f605.png'
    },
    {
      name: 'laughing',
      image: '1f606.png'
    },
    {
      name: 'innocent',
      image: '1f607.png'
    },
    {
      name: 'wink',
      image: '1f609.png'
    },
    {
      name: 'blush',
      image: '1f60a.png'
    },
    {
      name: 'relaxed',
      image: '263a.png'
    },
    {
      name: 'yum',
      image: '1f60b.png'
    },
    {
      name: 'relieved',
      image: '1f60c.png'
    },
    {
      name: 'heart_eyes',
      image: '1f60d.png'
    },
    {
      name: 'kissing_heart',
      image: '1f618.png'
    },
    {
      name: 'kissing',
      image: '1f617.png'
    },
    {
      name: 'kissing_smiling_eyes',
      image: '1f619.png'
    },
    {
      name: 'kissing_closed_eyes',
      image: '1f61a.png'
    },
    {
      name: 'stuck_out_tongue_winking_eye',
      image: '1f61c.png'
    },
    {
      name: 'stuck_out_tongue_closed_eyes',
      image: '1f61d.png'
    },
    {
      name: 'stuck_out_tongue',
      image: '1f61b.png'
    },
    {
      name: 'sunglasses',
      image: '1f60e.png'
    },
    {
      name: 'smirk',
      image: '1f60f.png'
    },
    {
      name: 'no_mouth',
      image: '1f636.png'
    },
    {
      name: 'neutral_face',
      image: '1f610.png'
    },
    {
      name: 'expressionless',
      image: '1f611.png'
    },
    {
      name: 'unamused',
      image: '1f612.png'
    },
    {
      name: 'flushed',
      image: '1f633.png'
    },
    {
      name: 'disappointed',
      image: '1f61e.png'
    },
    {
      name: 'worried',
      image: '1f61f.png'
    },
    {
      name: 'angry',
      image: '1f620.png'
    },
    {
      name: 'rage',
      image: '1f621.png'
    },
    {
      name: 'pensive',
      image: '1f614.png'
    },
    {
      name: 'confused',
      image: '1f615.png'
    },
    {
      name: 'persevere',
      image: '1f623.png'
    },
    {
      name: 'confounded',
      image: '1f616.png'
    },
    {
      name: 'tired_face',
      image: '1f62b.png'
    },
    {
      name: 'weary',
      image: '1f629.png'
    },
    {
      name: 'triumph',
      image: '1f624.png'
    },
    {
      name: 'open_mouth',
      image: '1f62e.png'
    },
    {
      name: 'scream',
      image: '1f631.png'
    },
    {
      name: 'fearful',
      image: '1f628.png'
    },
    {
      name: 'cold_sweat',
      image: '1f630.png'
    },
    {
      name: 'hushed',
      image: '1f62f.png'
    },
    {
      name: 'frowning',
      image: '1f626.png'
    },
    {
      name: 'anguished',
      image: '1f627.png'
    },
    {
      name: 'cry',
      image: '1f622.png'
    },
    {
      name: 'disappointed_relieved',
      image: '1f625.png'
    },
    {
      name: 'sleepy',
      image: '1f62a.png'
    },
    {
      name: 'sweat',
      image: '1f613.png'
    },
    {
      name: 'sob',
      image: '1f62d.png'
    },
    {
      name: 'dizzy_face',
      image: '1f635.png'
    },
    {
      name: 'astonished',
      image: '1f632.png'
    },
    {
      name: 'mask',
      image: '1f637.png'
    },
    {
      name: 'sleeping',
      image: '1f634.png'
    },
    {
      name: 'zzz',
      image: '1f4a4.png'
    },
    {
      name: 'hankey',
      image: '1f4a9.png'
    },
    {
      name: 'smiling_imp',
      image: '1f608.png'
    },
    {
      name: 'imp',
      image: '1f47f.png'
    },
    {
      name: 'japanese_ogre',
      image: '1f479.png'
    },
    {
      name: 'japanese_goblin',
      image: '1f47a.png'
    },
    {
      name: 'skull',
      image: '1f480.png'
    },
    {
      name: 'ghost',
      image: '1f47b.png'
    },
    {
      name: 'alien',
      image: '1f47d.png'
    },
    {
      name: 'smiley_cat',
      image: '1f63a.png'
    },
    {
      name: 'smile_cat',
      image: '1f638.png'
    },
    {
      name: 'joy_cat',
      image: '1f639.png'
    },
    {
      name: 'heart_eyes_cat',
      image: '1f63b.png'
    },
    {
      name: 'smirk_cat',
      image: '1f63c.png'
    },
    {
      name: 'kissing_cat',
      image: '1f63d.png'
    },
    {
      name: 'scream_cat',
      image: '1f640.png'
    },
    {
      name: 'crying_cat_face',
      image: '1f63f.png'
    },
    {
      name: 'pouting_cat',
      image: '1f63e.png'
    },
    {
      name: 'raised_hands',
      image: '1f64c.png'
    },
    {
      name: 'clap',
      image: '1f44f.png'
    },
    {
      name: 'wave',
      image: '1f44b.png'
    },
    {
      name: '+1',
      image: '1f44d.png'
    },
    {
      name: '-1',
      image: '1f44e.png'
    },
    {
      name: 'facepunch',
      image: '1f44a.png'
    },
    {
      name: 'fist',
      image: '270a.png'
    },
    {
      name: 'v',
      image: '270c.png'
    },
    {
      name: 'ok_hand',
      image: '1f44c.png'
    },
    {
      name: 'hand',
      image: '270b.png'
    },
    {
      name: 'open_hands',
      image: '1f450.png'
    },
    {
      name: 'muscle',
      image: '1f4aa.png'
    },
    {
      name: 'pray',
      image: '1f64f.png'
    },
    {
      name: 'point_up',
      image: '261d.png'
    },
    {
      name: 'point_up_2',
      image: '1f446.png'
    },
    {
      name: 'point_down',
      image: '1f447.png'
    },
    {
      name: 'point_left',
      image: '1f448.png'
    },
    {
      name: 'point_right',
      image: '1f449.png'
    },
    {
      name: 'nail_care',
      image: '1f485.png'
    },
    {
      name: 'lips',
      image: '1f444.png'
    },
    {
      name: 'tongue',
      image: '1f445.png'
    },
    {
      name: 'ear',
      image: '1f442.png'
    },
    {
      name: 'nose',
      image: '1f443.png'
    },
    {
      name: 'eyes',
      image: '1f440.png'
    },
    {
      name: 'bust_in_silhouette',
      image: '1f464.png'
    },
    {
      name: 'baby',
      image: '1f476.png'
    },
    {
      name: 'boy',
      image: '1f466.png'
    },
    {
      name: 'girl',
      image: '1f467.png'
    },
    {
      name: 'man',
      image: '1f468.png'
    },
    {
      name: 'woman',
      image: '1f469.png'
    },
    {
      name: 'person_with_blond_hair',
      image: '1f471.png'
    },
    {
      name: 'older_man',
      image: '1f474.png'
    },
    {
      name: 'older_woman',
      image: '1f475.png'
    },
    {
      name: 'man_with_gua_pi_mao',
      image: '1f472.png'
    },
    {
      name: 'man_with_turban',
      image: '1f473.png'
    },
    {
      name: 'cop',
      image: '1f46e.png'
    },
    {
      name: 'construction_worker',
      image: '1f477.png'
    },
    {
      name: 'guardsman',
      image: '1f482.png'
    },
    {
      name: 'santa',
      image: '1f385.png'
    },
    {
      name: 'angel',
      image: '1f47c.png'
    },
    {
      name: 'princess',
      image: '1f478.png'
    },
    {
      name: 'bride_with_veil',
      image: '1f470.png'
    },
    {
      name: 'walking',
      image: '1f6b6.png'
    },
    {
      name: 'runner',
      image: '1f3c3.png'
    },
    {
      name: 'dancer',
      image: '1f483.png'
    },
    {
      name: 'dancers',
      image: '1f46f.png'
    },
    {
      name: 'couple',
      image: '1f46b.png'
    },
    {
      name: 'two_women_holding_hands',
      image: '1f46d.png'
    },
    {
      name: 'two_men_holding_hands',
      image: '1f46c.png'
    },
    {
      name: 'bow',
      image: '1f647.png'
    },
    {
      name: 'information_desk_person',
      image: '1f481.png'
    },
    {
      name: 'no_good',
      image: '1f645.png'
    },
    {
      name: 'ok_woman',
      image: '1f646.png'
    },
    {
      name: 'raising_hand',
      image: '1f64b.png'
    },
    {
      name: 'person_with_pouting_face',
      image: '1f64e.png'
    },
    {
      name: 'person_frowning',
      image: '1f64d.png'
    },
    {
      name: 'haircut',
      image: '1f487.png'
    },
    {
      name: 'massage',
      image: '1f486.png'
    },
    {
      name: 'couple_with_heart',
      image: '1f491.png'
    },
    {
      name: 'couplekiss',
      image: '1f48f.png'
    },
    {
      name: 'family',
      image: '1f46a.png'
    },
    {
      name: 'womans_clothes',
      image: '1f45a.png'
    },
    {
      name: 'shirt',
      image: '1f455.png'
    },
    {
      name: 'jeans',
      image: '1f456.png'
    },
    {
      name: 'necktie',
      image: '1f454.png'
    },
    {
      name: 'dress',
      image: '1f457.png'
    },
    {
      name: 'bikini',
      image: '1f459.png'
    },
    {
      name: 'kimono',
      image: '1f458.png'
    },
    {
      name: 'lipstick',
      image: '1f484.png'
    },
    {
      name: 'kiss',
      image: '1f48b.png'
    },
    {
      name: 'footprints',
      image: '1f463.png'
    },
    {
      name: 'high_heel',
      image: '1f460.png'
    },
    {
      name: 'sandal',
      image: '1f461.png'
    },
    {
      name: 'boot',
      image: '1f462.png'
    },
    {
      name: 'mans_shoe',
      image: '1f45e.png'
    },
    {
      name: 'athletic_shoe',
      image: '1f45f.png'
    },
    {
      name: 'womans_hat',
      image: '1f452.png'
    },
    {
      name: 'tophat',
      image: '1f3a9.png'
    },
    {
      name: 'mortar_board',
      image: '1f393.png'
    },
    {
      name: 'crown',
      image: '1f451.png'
    },
    {
      name: 'school_satchel',
      image: '1f392.png'
    },
    {
      name: 'pouch',
      image: '1f45d.png'
    },
    {
      name: 'purse',
      image: '1f45b.png'
    },
    {
      name: 'handbag',
      image: '1f45c.png'
    },
    {
      name: 'briefcase',
      image: '1f4bc.png'
    },
    {
      name: 'eyeglasses',
      image: '1f453.png'
    },
    {
      name: 'ring',
      image: '1f48d.png'
    },
    {
      name: 'closed_umbrella',
      image: '1f302.png'
    }
  ]
}, {
  category: 'Nature',
  emojis: [{
      name: 'dog',
      image: '1f436.png'
    },
    {
      name: 'cat',
      image: '1f431.png'
    },
    {
      name: 'mouse',
      image: '1f42d.png'
    },
    {
      name: 'hamster',
      image: '1f439.png'
    },
    {
      name: 'rabbit',
      image: '1f430.png'
    },
    {
      name: 'bear',
      image: '1f43b.png'
    },
    {
      name: 'panda_face',
      image: '1f43c.png'
    },
    {
      name: 'koala',
      image: '1f428.png'
    },
    {
      name: 'tiger',
      image: '1f42f.png'
    },
    {
      name: 'cow',
      image: '1f42e.png'
    },
    {
      name: 'pig',
      image: '1f437.png'
    },
    {
      name: 'pig_nose',
      image: '1f43d.png'
    },
    {
      name: 'frog',
      image: '1f438.png'
    },
    {
      name: 'octopus',
      image: '1f419.png'
    },
    {
      name: 'monkey_face',
      image: '1f435.png'
    },
    {
      name: 'see_no_evil',
      image: '1f648.png'
    },
    {
      name: 'hear_no_evil',
      image: '1f649.png'
    },
    {
      name: 'speak_no_evil',
      image: '1f64a.png'
    },
    {
      name: 'monkey',
      image: '1f412.png'
    },
    {
      name: 'chicken',
      image: '1f414.png'
    },
    {
      name: 'penguin',
      image: '1f427.png'
    },
    {
      name: 'bird',
      image: '1f426.png'
    },
    {
      name: 'baby_chick',
      image: '1f424.png'
    },
    {
      name: 'hatching_chick',
      image: '1f423.png'
    },
    {
      name: 'hatched_chick',
      image: '1f425.png'
    },
    {
      name: 'wolf',
      image: '1f43a.png'
    },
    {
      name: 'boar',
      image: '1f417.png'
    },
    {
      name: 'horse',
      image: '1f434.png'
    },
    {
      name: 'bee',
      image: '1f41d.png'
    },
    {
      name: 'bug',
      image: '1f41b.png'
    },
    {
      name: 'snail',
      image: '1f40c.png'
    },
    {
      name: 'beetle',
      image: '1f41e.png'
    },
    {
      name: 'ant',
      image: '1f41c.png'
    },
    {
      name: 'snake',
      image: '1f40d.png'
    },
    {
      name: 'turtle',
      image: '1f422.png'
    },
    {
      name: 'tropical_fish',
      image: '1f420.png'
    },
    {
      name: 'fish',
      image: '1f41f.png'
    },
    {
      name: 'blowfish',
      image: '1f421.png'
    },
    {
      name: 'dolphin',
      image: '1f42c.png'
    },
    {
      name: 'whale',
      image: '1f433.png'
    },
    {
      name: 'whale2',
      image: '1f40b.png'
    },
    {
      name: 'crocodile',
      image: '1f40a.png'
    },
    {
      name: 'leopard',
      image: '1f406.png'
    },
    {
      name: 'tiger2',
      image: '1f405.png'
    },
    {
      name: 'water_buffalo',
      image: '1f403.png'
    },
    {
      name: 'ox',
      image: '1f402.png'
    },
    {
      name: 'cow2',
      image: '1f404.png'
    },
    {
      name: 'dromedary_camel',
      image: '1f42a.png'
    },
    {
      name: 'camel',
      image: '1f42b.png'
    },
    {
      name: 'elephant',
      image: '1f418.png'
    },
    {
      name: 'goat',
      image: '1f410.png'
    },
    {
      name: 'ram',
      image: '1f40f.png'
    },
    {
      name: 'sheep',
      image: '1f411.png'
    },
    {
      name: 'racehorse',
      image: '1f40e.png'
    },
    {
      name: 'pig2',
      image: '1f416.png'
    },
    {
      name: 'rat',
      image: '1f400.png'
    },
    {
      name: 'mouse2',
      image: '1f401.png'
    },
    {
      name: 'rooster',
      image: '1f413.png'
    },
    {
      name: 'dog2',
      image: '1f415.png'
    },
    {
      name: 'poodle',
      image: '1f429.png'
    },
    {
      name: 'cat2',
      image: '1f408.png'
    },
    {
      name: 'rabbit2',
      image: '1f407.png'
    },
    {
      name: 'feet',
      image: '1f43e.png'
    },
    {
      name: 'dragon',
      image: '1f409.png'
    },
    {
      name: 'dragon_face',
      image: '1f432.png'
    },
    {
      name: 'cactus',
      image: '1f335.png'
    },
    {
      name: 'christmas_tree',
      image: '1f384.png'
    },
    {
      name: 'evergreen_tree',
      image: '1f332.png'
    },
    {
      name: 'deciduous_tree',
      image: '1f333.png'
    },
    {
      name: 'palm_tree',
      image: '1f334.png'
    },
    {
      name: 'seedling',
      image: '1f331.png'
    },
    {
      name: 'herb',
      image: '1f33f.png'
    },
    {
      name: 'four_leaf_clover',
      image: '1f340.png'
    },
    {
      name: 'bamboo',
      image: '1f38d.png'
    },
    {
      name: 'tanabata_tree',
      image: '1f38b.png'
    },
    {
      name: 'leaves',
      image: '1f343.png'
    },
    {
      name: 'fallen_leaf',
      image: '1f342.png'
    },
    {
      name: 'maple_leaf',
      image: '1f341.png'
    },
    {
      name: 'ear_of_rice',
      image: '1f33e.png'
    },
    {
      name: 'hibiscus',
      image: '1f33a.png'
    },
    {
      name: 'sunflower',
      image: '1f33b.png'
    },
    {
      name: 'rose',
      image: '1f339.png'
    },
    {
      name: 'tulip',
      image: '1f337.png'
    },
    {
      name: 'blossom',
      image: '1f33c.png'
    },
    {
      name: 'cherry_blossom',
      image: '1f338.png'
    },
    {
      name: 'bouquet',
      image: '1f490.png'
    },
    {
      name: 'mushroom',
      image: '1f344.png'
    },
    {
      name: 'chestnut',
      image: '1f330.png'
    },
    {
      name: 'jack_o_lantern',
      image: '1f383.png'
    },
    {
      name: 'shell',
      image: '1f41a.png'
    },
    {
      name: 'earth_americas',
      image: '1f30e.png'
    },
    {
      name: 'earth_africa',
      image: '1f30d.png'
    },
    {
      name: 'earth_asia',
      image: '1f30f.png'
    },
    {
      name: 'full_moon',
      image: '1f315.png'
    },
    {
      name: 'waning_gibbous_moon',
      image: '1f316.png'
    },
    {
      name: 'last_quarter_moon',
      image: '1f317.png'
    },
    {
      name: 'waning_crescent_moon',
      image: '1f318.png'
    },
    {
      name: 'new_moon',
      image: '1f311.png'
    },
    {
      name: 'waxing_crescent_moon',
      image: '1f312.png'
    },
    {
      name: 'first_quarter_moon',
      image: '1f313.png'
    },
    {
      name: 'moon',
      image: '1f314.png'
    },
    {
      name: 'new_moon_with_face',
      image: '1f31a.png'
    },
    {
      name: 'full_moon_with_face',
      image: '1f31d.png'
    },
    {
      name: 'first_quarter_moon_with_face',
      image: '1f31b.png'
    },
    {
      name: 'last_quarter_moon_with_face',
      image: '1f31c.png'
    },
    {
      name: 'sun_with_face',
      image: '1f31e.png'
    },
    {
      name: 'crescent_moon',
      image: '1f319.png'
    },
    {
      name: 'star',
      image: '2b50.png'
    },
    {
      name: 'star2',
      image: '1f31f.png'
    },
    {
      name: 'dizzy',
      image: '1f4ab.png'
    },
    {
      name: 'sparkles',
      image: '2728.png'
    },
    {
      name: 'sunny',
      image: '2600.png'
    },
    {
      name: 'partly_sunny',
      image: '26c5.png'
    },
    {
      name: 'cloud',
      image: '2601.png'
    },
    {
      name: 'zap',
      image: '26a1.png'
    },
    {
      name: 'fire',
      image: '1f525.png'
    },
    {
      name: 'boom',
      image: '1f4a5.png'
    },
    {
      name: 'snowflake',
      image: '2744.png'
    },
    {
      name: 'snowman',
      image: '26c4.png'
    },
    {
      name: 'dash',
      image: '1f4a8.png'
    },
    {
      name: 'umbrella',
      image: '2614.png'
    },
    {
      name: 'droplet',
      image: '1f4a7.png'
    },
    {
      name: 'sweat_drops',
      image: '1f4a6.png'
    },
    {
      name: 'ocean',
      image: '1f30a.png'
    }
  ]
}, {
  category: 'Food & Drink',
  emojis: [{
      name: 'green_apple',
      image: '1f34f.png'
    },
    {
      name: 'apple',
      image: '1f34e.png'
    },
    {
      name: 'pear',
      image: '1f350.png'
    },
    {
      name: 'tangerine',
      image: '1f34a.png'
    },
    {
      name: 'lemon',
      image: '1f34b.png'
    },
    {
      name: 'banana',
      image: '1f34c.png'
    },
    {
      name: 'watermelon',
      image: '1f349.png'
    },
    {
      name: 'grapes',
      image: '1f347.png'
    },
    {
      name: 'strawberry',
      image: '1f353.png'
    },
    {
      name: 'melon',
      image: '1f348.png'
    },
    {
      name: 'cherries',
      image: '1f352.png'
    },
    {
      name: 'peach',
      image: '1f351.png'
    },
    {
      name: 'pineapple',
      image: '1f34d.png'
    },
    {
      name: 'tomato',
      image: '1f345.png'
    },
    {
      name: 'eggplant',
      image: '1f346.png'
    },
    {
      name: 'corn',
      image: '1f33d.png'
    },
    {
      name: 'sweet_potato',
      image: '1f360.png'
    },
    {
      name: 'honey_pot',
      image: '1f36f.png'
    },
    {
      name: 'bread',
      image: '1f35e.png'
    },
    {
      name: 'poultry_leg',
      image: '1f357.png'
    },
    {
      name: 'meat_on_bone',
      image: '1f356.png'
    },
    {
      name: 'fried_shrimp',
      image: '1f364.png'
    },
    {
      name: 'egg',
      image: '1f373.png'
    },
    {
      name: 'hamburger',
      image: '1f354.png'
    },
    {
      name: 'fries',
      image: '1f35f.png'
    },
    {
      name: 'pizza',
      image: '1f355.png'
    },
    {
      name: 'spaghetti',
      image: '1f35d.png'
    },
    {
      name: 'ramen',
      image: '1f35c.png'
    },
    {
      name: 'stew',
      image: '1f372.png'
    },
    {
      name: 'fish_cake',
      image: '1f365.png'
    },
    {
      name: 'sushi',
      image: '1f363.png'
    },
    {
      name: 'bento',
      image: '1f371.png'
    },
    {
      name: 'curry',
      image: '1f35b.png'
    },
    {
      name: 'rice_ball',
      image: '1f359.png'
    },
    {
      name: 'rice',
      image: '1f35a.png'
    },
    {
      name: 'rice_cracker',
      image: '1f358.png'
    },
    {
      name: 'oden',
      image: '1f362.png'
    },
    {
      name: 'dango',
      image: '1f361.png'
    },
    {
      name: 'shaved_ice',
      image: '1f367.png'
    },
    {
      name: 'ice_cream',
      image: '1f368.png'
    },
    {
      name: 'icecream',
      image: '1f366.png'
    },
    {
      name: 'cake',
      image: '1f370.png'
    },
    {
      name: 'birthday',
      image: '1f382.png'
    },
    {
      name: 'custard',
      image: '1f36e.png'
    },
    {
      name: 'candy',
      image: '1f36c.png'
    },
    {
      name: 'lollipop',
      image: '1f36d.png'
    },
    {
      name: 'chocolate_bar',
      image: '1f36b.png'
    },
    {
      name: 'doughnut',
      image: '1f369.png'
    },
    {
      name: 'cookie',
      image: '1f36a.png'
    },
    {
      name: 'beer',
      image: '1f37a.png'
    },
    {
      name: 'beers',
      image: '1f37b.png'
    },
    {
      name: 'wine_glass',
      image: '1f377.png'
    },
    {
      name: 'cocktail',
      image: '1f378.png'
    },
    {
      name: 'tropical_drink',
      image: '1f379.png'
    },
    {
      name: 'sake',
      image: '1f376.png'
    },
    {
      name: 'tea',
      image: '1f375.png'
    },
    {
      name: 'coffee',
      image: '2615.png'
    },
    {
      name: 'baby_bottle',
      image: '1f37c.png'
    },
    {
      name: 'fork_and_knife',
      image: '1f374.png'
    }
  ]
}, {
  category: 'Activity',
  emojis: [{
      name: 'soccer',
      image: '26bd.png'
    },
    {
      name: 'basketball',
      image: '1f3c0.png'
    },
    {
      name: 'football',
      image: '1f3c8.png'
    },
    {
      name: 'baseball',
      image: '26be.png'
    },
    {
      name: 'tennis',
      image: '1f3be.png'
    },
    {
      name: 'rugby_football',
      image: '1f3c9.png'
    },
    {
      name: '8ball',
      image: '1f3b1.png'
    },
    {
      name: 'golf',
      image: '26f3.png'
    },
    {
      name: 'ski',
      image: '1f3bf.png'
    },
    {
      name: 'snowboarder',
      image: '1f3c2.png'
    },
    {
      name: 'fishing_pole_and_fish',
      image: '1f3a3.png'
    },
    {
      name: 'rowboat',
      image: '1f6a3.png'
    },
    {
      name: 'swimmer',
      image: '1f3ca.png'
    },
    {
      name: 'surfer',
      image: '1f3c4.png'
    },
    {
      name: 'bath',
      image: '1f6c0.png'
    },
    {
      name: 'bicyclist',
      image: '1f6b4.png'
    },
    {
      name: 'mountain_bicyclist',
      image: '1f6b5.png'
    },
    {
      name: 'horse_racing',
      image: '1f3c7.png'
    },
    {
      name: 'trophy',
      image: '1f3c6.png'
    },
    {
      name: 'running_shirt_with_sash',
      image: '1f3bd.png'
    },
    {
      name: 'ticket',
      image: '1f3ab.png'
    },
    {
      name: 'performing_arts',
      image: '1f3ad.png'
    },
    {
      name: 'art',
      image: '1f3a8.png'
    },
    {
      name: 'circus_tent',
      image: '1f3aa.png'
    },
    {
      name: 'microphone',
      image: '1f3a4.png'
    },
    {
      name: 'headphones',
      image: '1f3a7.png'
    },
    {
      name: 'musical_score',
      image: '1f3bc.png'
    },
    {
      name: 'musical_keyboard',
      image: '1f3b9.png'
    },
    {
      name: 'saxophone',
      image: '1f3b7.png'
    },
    {
      name: 'trumpet',
      image: '1f3ba.png'
    },
    {
      name: 'guitar',
      image: '1f3b8.png'
    },
    {
      name: 'violin',
      image: '1f3bb.png'
    },
    {
      name: 'clapper',
      image: '1f3ac.png'
    },
    {
      name: 'video_game',
      image: '1f3ae.png'
    },
    {
      name: 'space_invader',
      image: '1f47e.png'
    },
    {
      name: 'dart',
      image: '1f3af.png'
    },
    {
      name: 'game_die',
      image: '1f3b2.png'
    },
    {
      name: 'slot_machine',
      image: '1f3b0.png'
    },
    {
      name: 'bowling',
      image: '1f3b3.png'
    }
  ]
}, {
  category: 'Travel & Places',
  emojis: [{
      name: 'car',
      image: '1f697.png'
    },
    {
      name: 'taxi',
      image: '1f695.png'
    },
    {
      name: 'blue_car',
      image: '1f699.png'
    },
    {
      name: 'bus',
      image: '1f68c.png'
    },
    {
      name: 'trolleybus',
      image: '1f68e.png'
    },
    {
      name: 'police_car',
      image: '1f693.png'
    },
    {
      name: 'ambulance',
      image: '1f691.png'
    },
    {
      name: 'fire_engine',
      image: '1f692.png'
    },
    {
      name: 'minibus',
      image: '1f690.png'
    },
    {
      name: 'truck',
      image: '1f69a.png'
    },
    {
      name: 'articulated_lorry',
      image: '1f69b.png'
    },
    {
      name: 'tractor',
      image: '1f69c.png'
    },
    {
      name: 'bike',
      image: '1f6b2.png'
    },
    {
      name: 'rotating_light',
      image: '1f6a8.png'
    },
    {
      name: 'oncoming_police_car',
      image: '1f694.png'
    },
    {
      name: 'oncoming_bus',
      image: '1f68d.png'
    },
    {
      name: 'oncoming_automobile',
      image: '1f698.png'
    },
    {
      name: 'oncoming_taxi',
      image: '1f696.png'
    },
    {
      name: 'aerial_tramway',
      image: '1f6a1.png'
    },
    {
      name: 'mountain_cableway',
      image: '1f6a0.png'
    },
    {
      name: 'suspension_railway',
      image: '1f69f.png'
    },
    {
      name: 'railway_car',
      image: '1f683.png'
    },
    {
      name: 'train',
      image: '1f68b.png'
    },
    {
      name: 'monorail',
      image: '1f69d.png'
    },
    {
      name: 'bullettrain_side',
      image: '1f684.png'
    },
    {
      name: 'bullettrain_front',
      image: '1f685.png'
    },
    {
      name: 'light_rail',
      image: '1f688.png'
    },
    {
      name: 'mountain_railway',
      image: '1f69e.png'
    },
    {
      name: 'steam_locomotive',
      image: '1f682.png'
    },
    {
      name: 'train2',
      image: '1f686.png'
    },
    {
      name: 'metro',
      image: '1f687.png'
    },
    {
      name: 'tram',
      image: '1f68a.png'
    },
    {
      name: 'station',
      image: '1f689.png'
    },
    {
      name: 'helicopter',
      image: '1f681.png'
    },
    {
      name: 'airplane',
      image: '2708.png'
    },
    {
      name: 'boat',
      image: '26f5.png'
    },
    {
      name: 'speedboat',
      image: '1f6a4.png'
    },
    {
      name: 'rocket',
      image: '1f680.png'
    },
    {
      name: 'satellite',
      image: '1f4e1.png'
    },
    {
      name: 'seat',
      image: '1f4ba.png'
    },
    {
      name: 'anchor',
      image: '2693.png'
    },
    {
      name: 'construction',
      image: '1f6a7.png'
    },
    {
      name: 'fuelpump',
      image: '26fd.png'
    },
    {
      name: 'busstop',
      image: '1f68f.png'
    },
    {
      name: 'vertical_traffic_light',
      image: '1f6a6.png'
    },
    {
      name: 'traffic_light',
      image: '1f6a5.png'
    },
    {
      name: 'checkered_flag',
      image: '1f3c1.png'
    },
    {
      name: 'ship',
      image: '1f6a2.png'
    },
    {
      name: 'ferris_wheel',
      image: '1f3a1.png'
    },
    {
      name: 'roller_coaster',
      image: '1f3a2.png'
    },
    {
      name: 'carousel_horse',
      image: '1f3a0.png'
    },
    {
      name: 'foggy',
      image: '1f301.png'
    },
    {
      name: 'tokyo_tower',
      image: '1f5fc.png'
    },
    {
      name: 'factory',
      image: '1f3ed.png'
    },
    {
      name: 'fountain',
      image: '26f2.png'
    },
    {
      name: 'rice_scene',
      image: '1f391.png'
    },
    {
      name: 'mount_fuji',
      image: '1f5fb.png'
    },
    {
      name: 'volcano',
      image: '1f30b.png'
    },
    {
      name: 'japan',
      image: '1f5fe.png'
    },
    {
      name: 'tent',
      image: '26fa.png'
    },
    {
      name: 'sunrise',
      image: '1f305.png'
    },
    {
      name: 'sunrise_over_mountains',
      image: '1f304.png'
    },
    {
      name: 'city_sunrise',
      image: '1f307.png'
    },
    {
      name: 'city_sunset',
      image: '1f306.png'
    },
    {
      name: 'night_with_stars',
      image: '1f303.png'
    },
    {
      name: 'bridge_at_night',
      image: '1f309.png'
    },
    {
      name: 'milky_way',
      image: '1f30c.png'
    },
    {
      name: 'stars',
      image: '1f320.png'
    },
    {
      name: 'sparkler',
      image: '1f387.png'
    },
    {
      name: 'fireworks',
      image: '1f386.png'
    },
    {
      name: 'rainbow',
      image: '1f308.png'
    },
    {
      name: 'european_castle',
      image: '1f3f0.png'
    },
    {
      name: 'japanese_castle',
      image: '1f3ef.png'
    },
    {
      name: 'statue_of_liberty',
      image: '1f5fd.png'
    },
    {
      name: 'house',
      image: '1f3e0.png'
    },
    {
      name: 'house_with_garden',
      image: '1f3e1.png'
    },
    {
      name: 'office',
      image: '1f3e2.png'
    },
    {
      name: 'department_store',
      image: '1f3ec.png'
    },
    {
      name: 'post_office',
      image: '1f3e3.png'
    },
    {
      name: 'european_post_office',
      image: '1f3e4.png'
    },
    {
      name: 'hospital',
      image: '1f3e5.png'
    },
    {
      name: 'bank',
      image: '1f3e6.png'
    },
    {
      name: 'hotel',
      image: '1f3e8.png'
    },
    {
      name: 'convenience_store',
      image: '1f3ea.png'
    },
    {
      name: 'school',
      image: '1f3eb.png'
    },
    {
      name: 'love_hotel',
      image: '1f3e9.png'
    },
    {
      name: 'wedding',
      image: '1f492.png'
    },
    {
      name: 'church',
      image: '26ea.png'
    }
  ]
}, {
  category: 'Objects',
  emojis: [{
      name: 'watch',
      image: '231a.png'
    },
    {
      name: 'iphone',
      image: '1f4f1.png'
    },
    {
      name: 'calling',
      image: '1f4f2.png'
    },
    {
      name: 'computer',
      image: '1f4bb.png'
    },
    {
      name: 'minidisc',
      image: '1f4bd.png'
    },
    {
      name: 'floppy_disk',
      image: '1f4be.png'
    },
    {
      name: 'cd',
      image: '1f4bf.png'
    },
    {
      name: 'dvd',
      image: '1f4c0.png'
    },
    {
      name: 'vhs',
      image: '1f4fc.png'
    },
    {
      name: 'camera',
      image: '1f4f7.png'
    },
    {
      name: 'video_camera',
      image: '1f4f9.png'
    },
    {
      name: 'movie_camera',
      image: '1f3a5.png'
    },
    {
      name: 'telephone_receiver',
      image: '1f4de.png'
    },
    {
      name: 'phone',
      image: '260e.png'
    },
    {
      name: 'pager',
      image: '1f4df.png'
    },
    {
      name: 'fax',
      image: '1f4e0.png'
    },
    {
      name: 'tv',
      image: '1f4fa.png'
    },
    {
      name: 'radio',
      image: '1f4fb.png'
    },
    {
      name: 'alarm_clock',
      image: '23f0.png'
    },
    {
      name: 'hourglass_flowing_sand',
      image: '23f3.png'
    },
    {
      name: 'hourglass',
      image: '231b.png'
    },
    {
      name: 'satellite',
      image: '1f4e1.png'
    },
    {
      name: 'battery',
      image: '1f50b.png'
    },
    {
      name: 'electric_plug',
      image: '1f50c.png'
    },
    {
      name: 'bulb',
      image: '1f4a1.png'
    },
    {
      name: 'flashlight',
      image: '1f526.png'
    },
    {
      name: 'money_with_wings',
      image: '1f4b8.png'
    },
    {
      name: 'dollar',
      image: '1f4b5.png'
    },
    {
      name: 'yen',
      image: '1f4b4.png'
    },
    {
      name: 'euro',
      image: '1f4b6.png'
    },
    {
      name: 'pound',
      image: '1f4b7.png'
    },
    {
      name: 'moneybag',
      image: '1f4b0.png'
    },
    {
      name: 'credit_card',
      image: '1f4b3.png'
    },
    {
      name: 'gem',
      image: '1f48e.png'
    },
    {
      name: 'wrench',
      image: '1f527.png'
    },
    {
      name: 'hammer',
      image: '1f528.png'
    },
    {
      name: 'nut_and_bolt',
      image: '1f529.png'
    },
    {
      name: 'gun',
      image: '1f52b.png'
    },
    {
      name: 'bomb',
      image: '1f4a3.png'
    },
    {
      name: 'hocho',
      image: '1f52a.png'
    },
    {
      name: 'smoking',
      image: '1f6ac.png'
    },
    {
      name: 'crystal_ball',
      image: '1f52e.png'
    },
    {
      name: 'barber',
      image: '1f488.png'
    },
    {
      name: 'telescope',
      image: '1f52d.png'
    },
    {
      name: 'microscope',
      image: '1f52c.png'
    },
    {
      name: 'pill',
      image: '1f48a.png'
    },
    {
      name: 'syringe',
      image: '1f489.png'
    },
    {
      name: 'bookmark',
      image: '1f516.png'
    },
    {
      name: 'toilet',
      image: '1f6bd.png'
    },
    {
      name: 'shower',
      image: '1f6bf.png'
    },
    {
      name: 'bathtub',
      image: '1f6c1.png'
    },
    {
      name: 'key',
      image: '1f511.png'
    },
    {
      name: 'door',
      image: '1f6aa.png'
    },
    {
      name: 'moyai',
      image: '1f5ff.png'
    },
    {
      name: 'balloon',
      image: '1f388.png'
    },
    {
      name: 'flags',
      image: '1f38f.png'
    },
    {
      name: 'ribbon',
      image: '1f380.png'
    },
    {
      name: 'gift',
      image: '1f381.png'
    },
    {
      name: 'confetti_ball',
      image: '1f38a.png'
    },
    {
      name: 'tada',
      image: '1f389.png'
    },
    {
      name: 'dolls',
      image: '1f38e.png'
    },
    {
      name: 'wind_chime',
      image: '1f390.png'
    },
    {
      name: 'crossed_flags',
      image: '1f38c.png'
    },
    {
      name: 'izakaya_lantern',
      image: '1f3ee.png'
    },
    {
      name: 'email',
      image: '2709.png'
    },
    {
      name: 'envelope_with_arrow',
      image: '1f4e9.png'
    },
    {
      name: 'incoming_envelope',
      image: '1f4e8.png'
    },
    {
      name: 'e-mail',
      image: '1f4e7.png'
    },
    {
      name: 'love_letter',
      image: '1f48c.png'
    },
    {
      name: 'postbox',
      image: '1f4ee.png'
    },
    {
      name: 'mailbox_closed',
      image: '1f4ea.png'
    },
    {
      name: 'mailbox',
      image: '1f4eb.png'
    },
    {
      name: 'mailbox_with_mail',
      image: '1f4ec.png'
    },
    {
      name: 'mailbox_with_no_mail',
      image: '1f4ed.png'
    },
    {
      name: 'package',
      image: '1f4e6.png'
    },
    {
      name: 'postal_horn',
      image: '1f4ef.png'
    },
    {
      name: 'inbox_tray',
      image: '1f4e5.png'
    },
    {
      name: 'outbox_tray',
      image: '1f4e4.png'
    },
    {
      name: 'scroll',
      image: '1f4dc.png'
    },
    {
      name: 'page_with_curl',
      image: '1f4c3.png'
    },
    {
      name: 'bookmark_tabs',
      image: '1f4d1.png'
    },
    {
      name: 'bar_chart',
      image: '1f4ca.png'
    },
    {
      name: 'chart_with_upwards_trend',
      image: '1f4c8.png'
    },
    {
      name: 'chart_with_downwards_trend',
      image: '1f4c9.png'
    },
    {
      name: 'page_facing_up',
      image: '1f4c4.png'
    },
    {
      name: 'date',
      image: '1f4c5.png'
    },
    {
      name: 'calendar',
      image: '1f4c6.png'
    },
    {
      name: 'card_index',
      image: '1f4c7.png'
    },
    {
      name: 'clipboard',
      image: '1f4cb.png'
    },
    {
      name: 'file_folder',
      image: '1f4c1.png'
    },
    {
      name: 'open_file_folder',
      image: '1f4c2.png'
    },
    {
      name: 'newspaper',
      image: '1f4f0.png'
    },
    {
      name: 'notebook',
      image: '1f4d3.png'
    },
    {
      name: 'closed_book',
      image: '1f4d5.png'
    },
    {
      name: 'green_book',
      image: '1f4d7.png'
    },
    {
      name: 'blue_book',
      image: '1f4d8.png'
    },
    {
      name: 'orange_book',
      image: '1f4d9.png'
    },
    {
      name: 'notebook_with_decorative_cover',
      image: '1f4d4.png'
    },
    {
      name: 'ledger',
      image: '1f4d2.png'
    },
    {
      name: 'books',
      image: '1f4da.png'
    },
    {
      name: 'book',
      image: '1f4d6.png'
    },
    {
      name: 'link',
      image: '1f517.png'
    },
    {
      name: 'paperclip',
      image: '1f4ce.png'
    },
    {
      name: 'scissors',
      image: '2702.png'
    },
    {
      name: 'triangular_ruler',
      image: '1f4d0.png'
    },
    {
      name: 'straight_ruler',
      image: '1f4cf.png'
    },
    {
      name: 'pushpin',
      image: '1f4cc.png'
    },
    {
      name: 'round_pushpin',
      image: '1f4cd.png'
    },
    {
      name: 'triangular_flag_on_post',
      image: '1f6a9.png'
    },
    {
      name: 'closed_lock_with_key',
      image: '1f510.png'
    },
    {
      name: 'lock',
      image: '1f512.png'
    },
    {
      name: 'unlock',
      image: '1f513.png'
    },
    {
      name: 'lock_with_ink_pen',
      image: '1f50f.png'
    },
    {
      name: 'black_nib',
      image: '2712.png'
    },
    {
      name: 'memo',
      image: '1f4dd.png'
    },
    {
      name: 'pencil2',
      image: '270f.png'
    },
    {
      name: 'mag',
      image: '1f50d.png'
    },
    {
      name: 'mag_right',
      image: '1f50e.png'
    }
  ]
}, {
  category: 'Symbols',
  emojis: [{
      name: 'heart',
      image: '2764.png'
    },
    {
      name: 'yellow_heart',
      image: '1f49b.png'
    },
    {
      name: 'green_heart',
      image: '1f49a.png'
    },
    {
      name: 'blue_heart',
      image: '1f499.png'
    },
    {
      name: 'purple_heart',
      image: '1f49c.png'
    },
    {
      name: 'broken_heart',
      image: '1f494.png'
    },
    {
      name: 'two_hearts',
      image: '1f495.png'
    },
    {
      name: 'revolving_hearts',
      image: '1f49e.png'
    },
    {
      name: 'heartbeat',
      image: '1f493.png'
    },
    {
      name: 'heartpulse',
      image: '1f497.png'
    },
    {
      name: 'sparkling_heart',
      image: '1f496.png'
    },
    {
      name: 'cupid',
      image: '1f498.png'
    },
    {
      name: 'gift_heart',
      image: '1f49d.png'
    },
    {
      name: 'heart_decoration',
      image: '1f49f.png'
    },
    {
      name: 'six_pointed_star',
      image: '1f52f.png'
    },
    {
      name: 'ophiuchus',
      image: '26ce.png'
    },
    {
      name: 'aries',
      image: '2648.png'
    },
    {
      name: 'taurus',
      image: '2649.png'
    },
    {
      name: 'gemini',
      image: '264a.png'
    },
    {
      name: 'cancer',
      image: '264b.png'
    },
    {
      name: 'leo',
      image: '264c.png'
    },
    {
      name: 'virgo',
      image: '264d.png'
    },
    {
      name: 'libra',
      image: '264e.png'
    },
    {
      name: 'scorpius',
      image: '264f.png'
    },
    {
      name: 'sagittarius',
      image: '2650.png'
    },
    {
      name: 'capricorn',
      image: '2651.png'
    },
    {
      name: 'aquarius',
      image: '2652.png'
    },
    {
      name: 'pisces',
      image: '2653.png'
    },
    {
      name: 'id',
      image: '1f194.png'
    },
    {
      name: 'u7a7a',
      image: '1f233.png'
    },
    {
      name: 'u5272',
      image: '1f239.png'
    },
    {
      name: 'mobile_phone_off',
      image: '1f4f4.png'
    },
    {
      name: 'vibration_mode',
      image: '1f4f3.png'
    },
    {
      name: 'u6709',
      image: '1f236.png'
    },
    {
      name: 'u7121',
      image: '1f21a.png'
    },
    {
      name: 'u7533',
      image: '1f238.png'
    },
    {
      name: 'u55b6',
      image: '1f23a.png'
    },
    {
      name: 'u6708',
      image: '1f237.png'
    },
    {
      name: 'eight_pointed_black_star',
      image: '2734.png'
    },
    {
      name: 'vs',
      image: '1f19a.png'
    },
    {
      name: 'accept',
      image: '1f251.png'
    },
    {
      name: 'white_flower',
      image: '1f4ae.png'
    },
    {
      name: 'ideograph_advantage',
      image: '1f250.png'
    },
    {
      name: 'secret',
      image: '3299.png'
    },
    {
      name: 'congratulations',
      image: '3297.png'
    },
    {
      name: 'u5408',
      image: '1f234.png'
    },
    {
      name: 'u6e80',
      image: '1f235.png'
    },
    {
      name: 'u7981',
      image: '1f232.png'
    },
    {
      name: 'a',
      image: '1f170.png'
    },
    {
      name: 'b',
      image: '1f171.png'
    },
    {
      name: 'ab',
      image: '1f18e.png'
    },
    {
      name: 'cl',
      image: '1f191.png'
    },
    {
      name: 'o2',
      image: '1f17e.png'
    },
    {
      name: 'sos',
      image: '1f198.png'
    },
    {
      name: 'no_entry',
      image: '26d4.png'
    },
    {
      name: 'name_badge',
      image: '1f4db.png'
    },
    {
      name: 'no_entry_sign',
      image: '1f6ab.png'
    },
    {
      name: 'x',
      image: '274c.png'
    },
    {
      name: 'o',
      image: '2b55.png'
    },
    {
      name: 'anger',
      image: '1f4a2.png'
    },
    {
      name: 'hotsprings',
      image: '2668.png'
    },
    {
      name: 'no_pedestrians',
      image: '1f6b7.png'
    },
    {
      name: 'do_not_litter',
      image: '1f6af.png'
    },
    {
      name: 'no_bicycles',
      image: '1f6b3.png'
    },
    {
      name: 'non-potable_water',
      image: '1f6b1.png'
    },
    {
      name: 'underage',
      image: '1f51e.png'
    },
    {
      name: 'no_mobile_phones',
      image: '1f4f5.png'
    },
    {
      name: 'exclamation',
      image: '2757.png'
    },
    {
      name: 'grey_exclamation',
      image: '2755.png'
    },
    {
      name: 'question',
      image: '2753.png'
    },
    {
      name: 'grey_question',
      image: '2754.png'
    },
    {
      name: 'bangbang',
      image: '203c.png'
    },
    {
      name: 'interrobang',
      image: '2049.png'
    },
    {
      name: '100',
      image: '1f4af.png'
    },
    {
      name: 'low_brightness',
      image: '1f505.png'
    },
    {
      name: 'high_brightness',
      image: '1f506.png'
    },
    {
      name: 'trident',
      image: '1f531.png'
    },
    {
      name: 'part_alternation_mark',
      image: '303d.png'
    },
    {
      name: 'warning',
      image: '26a0.png'
    },
    {
      name: 'children_crossing',
      image: '1f6b8.png'
    },
    {
      name: 'beginner',
      image: '1f530.png'
    },
    {
      name: 'recycle',
      image: '267b.png'
    },
    {
      name: 'u6307',
      image: '1f22f.png'
    },
    {
      name: 'chart',
      image: '1f4b9.png'
    },
    {
      name: 'sparkle',
      image: '2747.png'
    },
    {
      name: 'eight_spoked_asterisk',
      image: '2733.png'
    },
    {
      name: 'negative_squared_cross_mark',
      image: '274e.png'
    },
    {
      name: 'white_check_mark',
      image: '2705.png'
    },
    {
      name: 'diamond_shape_with_a_dot_inside',
      image: '1f4a0.png'
    },
    {
      name: 'cyclone',
      image: '1f300.png'
    },
    {
      name: 'loop',
      image: '27bf.png'
    },
    {
      name: 'globe_with_meridians',
      image: '1f310.png'
    },
    {
      name: 'm',
      image: '24c2.png'
    },
    {
      name: 'atm',
      image: '1f3e7.png'
    },
    {
      name: 'sa',
      image: '1f202.png'
    },
    {
      name: 'passport_control',
      image: '1f6c2.png'
    },
    {
      name: 'customs',
      image: '1f6c3.png'
    },
    {
      name: 'baggage_claim',
      image: '1f6c4.png'
    },
    {
      name: 'left_luggage',
      image: '1f6c5.png'
    },
    {
      name: 'wheelchair',
      image: '267f.png'
    },
    {
      name: 'no_smoking',
      image: '1f6ad.png'
    },
    {
      name: 'wc',
      image: '1f6be.png'
    },
    {
      name: 'parking',
      image: '1f17f.png'
    },
    {
      name: 'potable_water',
      image: '1f6b0.png'
    },
    {
      name: 'mens',
      image: '1f6b9.png'
    },
    {
      name: 'womens',
      image: '1f6ba.png'
    },
    {
      name: 'baby_symbol',
      image: '1f6bc.png'
    },
    {
      name: 'restroom',
      image: '1f6bb.png'
    },
    {
      name: 'put_litter_in_its_place',
      image: '1f6ae.png'
    },
    {
      name: 'cinema',
      image: '1f3a6.png'
    },
    {
      name: 'signal_strength',
      image: '1f4f6.png'
    },
    {
      name: 'koko',
      image: '1f201.png'
    },
    {
      name: 'ng',
      image: '1f196.png'
    },
    {
      name: 'ok',
      image: '1f197.png'
    },
    {
      name: 'up',
      image: '1f199.png'
    },
    {
      name: 'cool',
      image: '1f192.png'
    },
    {
      name: 'new',
      image: '1f195.png'
    },
    {
      name: 'free',
      image: '1f193.png'
    },
    {
      name: 'zero',
      image: '0030-20e3.png'
    },
    {
      name: 'one',
      image: '0031-20e3.png'
    },
    {
      name: 'two',
      image: '0032-20e3.png'
    },
    {
      name: 'three',
      image: '0033-20e3.png'
    },
    {
      name: 'four',
      image: '0034-20e3.png'
    },
    {
      name: 'five',
      image: '0035-20e3.png'
    },
    {
      name: 'six',
      image: '0036-20e3.png'
    },
    {
      name: 'seven',
      image: '0037-20e3.png'
    },
    {
      name: 'eight',
      image: '0038-20e3.png'
    },
    {
      name: 'nine',
      image: '0039-20e3.png'
    },
    {
      name: 'keycap_ten',
      image: '1f51f.png'
    },
    {
      name: '1234',
      image: '1f522.png'
    },
    {
      name: 'arrow_forward',
      image: '25b6.png'
    },
    {
      name: 'fast_forward',
      image: '23e9.png'
    },
    {
      name: 'rewind',
      image: '23ea.png'
    },
    {
      name: 'twisted_rightwards_arrows',
      image: '1f500.png'
    },
    {
      name: 'repeat',
      image: '1f501.png'
    },
    {
      name: 'repeat_one',
      image: '1f502.png'
    },
    {
      name: 'arrow_backward',
      image: '25c0.png'
    },
    {
      name: 'arrow_up_small',
      image: '1f53c.png'
    },
    {
      name: 'arrow_down_small',
      image: '1f53d.png'
    },
    {
      name: 'arrow_double_up',
      image: '23eb.png'
    },
    {
      name: 'arrow_double_down',
      image: '23ec.png'
    },
    {
      name: 'arrow_right',
      image: '27a1.png'
    },
    {
      name: 'arrow_left',
      image: '2b05.png'
    },
    {
      name: 'arrow_up',
      image: '2b06.png'
    },
    {
      name: 'arrow_down',
      image: '2b07.png'
    },
    {
      name: 'arrow_upper_right',
      image: '2197.png'
    },
    {
      name: 'arrow_lower_right',
      image: '2198.png'
    },
    {
      name: 'arrow_lower_left',
      image: '2199.png'
    },
    {
      name: 'arrow_upper_left',
      image: '2196.png'
    },
    {
      name: 'arrow_up_down',
      image: '2195.png'
    },
    {
      name: 'left_right_arrow',
      image: '2194.png'
    },
    {
      name: 'arrows_counterclockwise',
      image: '1f504.png'
    },
    {
      name: 'arrow_right_hook',
      image: '21aa.png'
    },
    {
      name: 'leftwards_arrow_with_hook',
      image: '21a9.png'
    },
    {
      name: 'arrow_heading_up',
      image: '2934.png'
    },
    {
      name: 'arrow_heading_down',
      image: '2935.png'
    },
    {
      name: 'hash',
      image: '0023-20e3.png'
    },
    {
      name: 'information_source',
      image: '2139.png'
    },
    {
      name: 'abc',
      image: '1f524.png'
    },
    {
      name: 'abcd',
      image: '1f521.png'
    },
    {
      name: 'capital_abcd',
      image: '1f520.png'
    },
    {
      name: 'symbols',
      image: '1f523.png'
    },
    {
      name: 'musical_note',
      image: '1f3b5.png'
    },
    {
      name: 'notes',
      image: '1f3b6.png'
    },
    {
      name: 'wavy_dash',
      image: '3030.png'
    },
    {
      name: 'curly_loop',
      image: '27b0.png'
    },
    {
      name: 'heavy_check_mark',
      image: '2714.png'
    },
    {
      name: 'arrows_clockwise',
      image: '1f503.png'
    },
    {
      name: 'heavy_plus_sign',
      image: '2795.png'
    },
    {
      name: 'heavy_minus_sign',
      image: '2796.png'
    },
    {
      name: 'heavy_division_sign',
      image: '2797.png'
    },
    {
      name: 'heavy_multiplication_x',
      image: '2716.png'
    },
    {
      name: 'heavy_dollar_sign',
      image: '1f4b2.png'
    },
    {
      name: 'currency_exchange',
      image: '1f4b1.png'
    },
    {
      name: 'tm',
      image: '2122.png'
    },
    {
      name: 'end',
      image: '1f51a.png'
    },
    {
      name: 'back',
      image: '1f519.png'
    },
    {
      name: 'on',
      image: '1f51b.png'
    },
    {
      name: 'top',
      image: '1f51d.png'
    },
    {
      name: 'soon',
      image: '1f51c.png'
    },
    {
      name: 'ballot_box_with_check',
      image: '2611.png'
    },
    {
      name: 'radio_button',
      image: '1f518.png'
    },
    {
      name: 'white_circle',
      image: '26aa.png'
    },
    {
      name: 'black_circle',
      image: '26ab.png'
    },
    {
      name: 'red_circle',
      image: '1f534.png'
    },
    {
      name: 'large_blue_circle',
      image: '1f535.png'
    },
    {
      name: 'small_orange_diamond',
      image: '1f538.png'
    },
    {
      name: 'small_blue_diamond',
      image: '1f539.png'
    },
    {
      name: 'large_orange_diamond',
      image: '1f536.png'
    },
    {
      name: 'large_blue_diamond',
      image: '1f537.png'
    },
    {
      name: 'small_red_triangle',
      image: '1f53a.png'
    },
    {
      name: 'black_small_square',
      image: '25aa.png'
    },
    {
      name: 'white_small_square',
      image: '25ab.png'
    },
    {
      name: 'black_large_square',
      image: '2b1b.png'
    },
    {
      name: 'white_large_square',
      image: '2b1c.png'
    },
    {
      name: 'small_red_triangle_down',
      image: '1f53b.png'
    },
    {
      name: 'black_medium_square',
      image: '25fc.png'
    },
    {
      name: 'white_medium_square',
      image: '25fb.png'
    },
    {
      name: 'black_medium_small_square',
      image: '25fe.png'
    },
    {
      name: 'white_medium_small_square',
      image: '25fd.png'
    },
    {
      name: 'black_square_button',
      image: '1f532.png'
    },
    {
      name: 'white_square_button',
      image: '1f533.png'
    },
    {
      name: 'speaker',
      image: '1f508.png'
    },
    {
      name: 'sound',
      image: '1f509.png'
    },
    {
      name: 'loud_sound',
      image: '1f50a.png'
    },
    {
      name: 'mute',
      image: '1f507.png'
    },
    {
      name: 'mega',
      image: '1f4e3.png'
    },
    {
      name: 'loudspeaker',
      image: '1f4e2.png'
    },
    {
      name: 'bell',
      image: '1f514.png'
    },
    {
      name: 'no_bell',
      image: '1f515.png'
    },
    {
      name: 'black_joker',
      image: '1f0cf.png'
    },
    {
      name: 'mahjong',
      image: '1f004.png'
    },
    {
      name: 'spades',
      image: '2660.png'
    },
    {
      name: 'clubs',
      image: '2663.png'
    },
    {
      name: 'hearts',
      image: '2665.png'
    },
    {
      name: 'diamonds',
      image: '2666.png'
    },
    {
      name: 'flower_playing_cards',
      image: '1f3b4.png'
    },
    {
      name: 'thought_balloon',
      image: '1f4ad.png'
    },
    {
      name: 'speech_balloon',
      image: '1f4ac.png'
    },
    {
      name: 'clock1',
      image: '1f550.png'
    },
    {
      name: 'clock2',
      image: '1f551.png'
    },
    {
      name: 'clock3',
      image: '1f552.png'
    },
    {
      name: 'clock4',
      image: '1f553.png'
    },
    {
      name: 'clock5',
      image: '1f554.png'
    },
    {
      name: 'clock6',
      image: '1f555.png'
    },
    {
      name: 'clock7',
      image: '1f556.png'
    },
    {
      name: 'clock8',
      image: '1f557.png'
    },
    {
      name: 'clock9',
      image: '1f558.png'
    },
    {
      name: 'clock10',
      image: '1f559.png'
    },
    {
      name: 'clock11',
      image: '1f55a.png'
    },
    {
      name: 'clock12',
      image: '1f55b.png'
    },
    {
      name: 'clock130',
      image: '1f55c.png'
    },
    {
      name: 'clock230',
      image: '1f55d.png'
    },
    {
      name: 'clock330',
      image: '1f55e.png'
    },
    {
      name: 'clock430',
      image: '1f55f.png'
    },
    {
      name: 'clock530',
      image: '1f560.png'
    },
    {
      name: 'clock630',
      image: '1f561.png'
    },
    {
      name: 'clock730',
      image: '1f562.png'
    },
    {
      name: 'clock830',
      image: '1f563.png'
    },
    {
      name: 'clock930',
      image: '1f564.png'
    },
    {
      name: 'clock1030',
      image: '1f565.png'
    },
    {
      name: 'clock1130',
      image: '1f566.png'
    },
    {
      name: 'clock1230',
      image: '1f567.png'
    }
  ]
}, {
  category: 'Flags',
  emojis: [{
      name: 'cn',
      image: '1f1e8-1f1f3.png'
    },
    {
      name: 'de',
      image: '1f1e9-1f1ea.png'
    },
    {
      name: 'es',
      image: '1f1ea-1f1f8.png'
    },
    {
      name: 'fr',
      image: '1f1eb-1f1f7.png'
    },
    {
      name: 'gb',
      image: '1f1ec-1f1e7.png'
    },
    {
      name: 'it',
      image: '1f1ee-1f1f9.png'
    },
    {
      name: 'jp',
      image: '1f1ef-1f1f5.png'
    },
    {
      name: 'kr',
      image: '1f1f0-1f1f7.png'
    },
    {
      name: 'ru',
      image: '1f1f7-1f1fa.png'
    },
    {
      name: 'us',
      image: '1f1fa-1f1f8.png'
    }
  ]
}];
